import request from '@/utils/request';

const baseURL = '/financeapi/finance/home/accountSet/'

export const updateAccountSet = data =>
  request({
    data,
    url: `${baseURL}updata`,
    method: 'post'
  });

export const findAccountSet = data =>
  request({
    data,
    url: `${baseURL}findAccountSet`,
    method: 'post'
  });

export const findStore = data =>
  request({
    data,
    url: `${baseURL}findStore`,
    method: 'post'
  });

export const addAccountSet = data =>
  request({
    data,
    url: `${baseURL}addAccountSet`,
    method: 'post'
  });

export const selectAccountSet = async accountSet => {
  await request({
    data: { code: accountSet.code },
    url: `${baseURL}selectAccountSet`,
    method: 'post'
  });

  localStorage.setItem('currentAccountSet', JSON.stringify(accountSet));
  if (window._reportSDK && window._reportSDK.setUserId) {
    window._reportSDK.setUserId(accountSet.userId);
  }
  await getBillPleaseStatus(true);
}

// 结账状态，0代表未结账
export const getBillPleaseStatus = async (refresh) => {
  if (refresh) {
    localStorage.removeItem('billPleaseStatus');
  }
  let res = JSON.parse(localStorage.getItem('billPleaseStatus') || '{}');
  if (res && res.status == 0) {
    return res;
  }
  res = await request({
    data: {},
    url: `/financeapi/finance/setting/billPlease/status`,
    method: 'post'
  });
  localStorage.setItem('billPleaseStatus', JSON.stringify(res));
  return res;
};
export const getCurrentAccountSet = () => {
  const currentAccountSetJson = localStorage.getItem('currentAccountSet');
  if (!currentAccountSetJson) {
    return null;
  }
  let accountSet = JSON.parse(currentAccountSetJson);
  if (window._reportSDK && window._reportSDK.setUserId) {
    window._reportSDK.setUserId(accountSet.userId);
  }
  return accountSet;
}
export const getCurrentAccountAliasOrName = () => {
  var accountSet = getCurrentAccountSet();
  if (!accountSet) {
    return '';
  }
  return accountSet.alias || accountSet.name;
}

export const removeCurrentAccountSet = () => {
  localStorage.removeItem('currentAccountSet');
}

export const findPeriodList = data =>
  request({
    data,
    url: `${baseURL}findPeriodList`,
    method: 'post'
  });

export const exportYongY = data =>
  request({
    data,
    url: `${baseURL}export/yongy`,
    method: 'post'
  });

export const importYongY = data =>
  request({
    data,
    url: `${baseURL}import/yongy`,
    method: 'post'
  });